export const MixpanelEvent = {
  USER_LANGUAGE_CHANGED: 'sho_user_language_changed',
  USER_MARKET_CHANGED: 'sho_user_market_changed',
  SIGN_IN_COMPLETED: 'sho_sign_in_completed',
  CREATE_ACCOUNT_COMPLETED: 'sho_create_account_completed',
  LOGOUT: 'sho_logout',
  PAGE_VIEW: 'sho_page_view',
  SIGN_IN_CLICKED: 'sho_sign_in_clicked',
  SIGN_IN_SERVER_ERROR: 'sho_sign_in_server_error',
  CREATE_ACCOUNT_CLICKED: 'sho_create_account_clicked',
  CREATE_ACCOUNT_VALIDATION_ERROR: 'sho_create_account_validation_error',
  CREATE_ACCOUNT_SERVER_ERROR: 'sho_create_account_server_error',
  ADD_TO_CART: 'sho_add_to_cart',
  REMOVE_FROM_CART: 'sho_remove_from_cart',
  VIEW_CART: 'sho_view_cart',
  SELECT_PRODUCT: 'sho_select_product',
  VIEW_PRODUCT: 'sho_view_product',
  CHECKOUT_BEGIN: 'sho_checkout_begin',
  CHECKOUT_ACCOUNT_DATA_ADDED: 'sho_checkout_account_data_added',
  CHECKOUT_SHIPPING_ADDED: 'sho_checkout_shipping_added',
  CHECKOUT_PURCHASE_CLICKED: 'sho_checkout_purchase_clicked',
  CHECKOUT_PURCHASE_VALIDATION_ERROR: 'sho_checkout_purchase_validation_error',
  CHECKOUT_PURCHASE_SERVER_ERROR: 'sho_checkout_purchase_server_error',
  CHECKOUT_PURCHASE_COMPLETED: 'sho_checkout_purchase_completed',
  SUBSCRIPTION_FLAVOR_CHANGED: 'sho_subscription_flavor_changed',
  SUBSCRIPTION_SHIP_NOW_CLICKED: 'sho_subscription_ship_now_clicked',
  SUBSCRIPTION_SHIP_NOW_SERVER_ERROR: 'sho_subscription_ship_now_server_error',
  SUBSCRIPTION_SHIP_NOW_SUCCEED: 'sho_subscription_ship_now_succeed',
  SUBSCRIPTION_SKIP_NEXT_DELIVERY_SUCCEED:
    'sho_subscription_skip_next_delivery_succeed',
  SUBSCRIPTION_DELIVERY_DATE_CHANGED: 'sho_subscription_delivery_date_changed',
  SUBSCRIPTION_CANCEL_CLICKED: 'sho_subscription_cancel_clicked',
  CANCEL_SUBSCRIPTION_SKIP_NEXT_DELIVERY_REJECTED:
    'sho_cancel_subscription_skip_next_delivery_rejected',
  CANCEL_SUBSCRIPTION_SELECT_REASON_SUCCEED:
    'sho_cancel_subscription_select_reason_succeed',
  NAVIGATION_BAR_CLICKED: 'sho_navigation_bar_clicked',
  NAVIGATION_BAR_SEARCH_CLICKED: 'sho_navigation_bar_search_clicked',
  NAVIGATION_BAR_SHOP_MENU_ITEM_CLICKED:
    'sho_navigation_bar_shop_menu_item_clicked',
  FOOTER_LINK_CLICKED: 'sho_footer_link_clicked',
  PRODUCTS_CATEGORY_BUTTON_CLICKED: 'sho_products_category_button_clicked',
  CART_SHARE_LINK_COPIED: 'sho_cart_share_link_copied',
  PRODUCT_DETAIL_DOWNLOAD_PDF_CLICKED:
    'sho_product_detail_download_pdf_clicked',
  PRODUCT_DETAIL_LINK_COPIED: 'sho_product_detail_link_copied',
  INITIALIZE_USER_PROFILE_FOR_OLD_USERS:
    'sho_initialize_user_profile_for_old_users',
  NAVIGATION_BAR_NAV_LINK_CLICKED: 'sho_navigation_bar_nav_link_clicked',
  PROFILE_MENU_OPENED: 'sho_profile_menu_opened',
  USER_MENU_NAVIGATION_CLICKED: 'sho_user_menu_navigation_clicked',
  USER_REFERRAL_LINK_COPIED: 'sho_user_referral_link_copied',
  USER_UNICITY_ID_COPIED: 'sho_user_unicity_id_copied',
  USER_REFERRAL_CODE_COPIED: 'sho_user_referral_code_copied',
  CREATE_OR_COMBINE_SUBSCRIPTION_APPEARS:
    'sho_create_or_combine_subscription_appears',
  CREATE_OR_COMBINE_SUBSCRIPTION_SELECTED:
    'sho_create_or_combine_subscription_selected',

  REVIEW_SUBSCRIPTION_CHANGES_CONFIRM_CLICKED:
    'sho_review_subscription_changes_confirm_clicked',
  REVIEW_SUBSCRIPTION_CHANGES_SERVER_ERROR:
    'sho_review_subscription_changes_server_error',
  SUBSCRIPTION_CHANGES_COMPLETED: 'sho_subscription_changes_completed',
  SUBSCRIPTION_ITEMS_AMOUNT_CHANGES: 'sho_subscription_items_amount_changed',
  SUBSCRIPTION_ADD_NEW_PRODUCT_CLICKED:
    'sho_subscription_add_new_product_clicked',
  SUBSCRIPTION_ADD_NEW_PRODUCT_DIALOG_RESOLVED:
    'sho_subscription_add_new_product_dialog_resolved',
  SUBSCRIPTION_ADD_NEW_PRODUCT_TUTORIAL_PRESENTED:
    'sho_subscription_add_new_product_tutorial_presented',
  SUBSCRIPTION_EDIT_ITEM_CLICKED: 'sho_subscription_edit_item_clicked',
  SUBSCRIPTION_EDIT_ITEM_SAVE_CLICKED:
    'sho_subscription_edit_item_save_clicked',
  SUBSCRIPTION_EDIT_ITEM_SAVE_SERVER_ERROR:
    'sho_subscription_edit_item_save_server_error',
  EXCLUSIVE_THANK_YOU_CLICKED: 'sho_thank_you_page_unicity_labs_banner_clicked',
  UNLOCK_PRODUCT_DETAIL_CLICKED:
    'sho_unicity_lab_product_detail_unlock_clicked',
  EXCLUSIVE_THANK_YOU_PRESENTED:
    'sho_thank_you_page_unicity_labs_banner_presented',
  CREDIT_CARD_SAVE_FAILURE: 'credit_card_save_failure',
} as const
